import React, { useState } from 'react';
import Modal from '../../../components/ui/Modal';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const AlertSettingsModal = ({ isOpen, onClose }) => {
  const [activeTab, setActiveTab] = useState('notifications');
  const [emailNotifications, setEmailNotifications] = useState(true);
  const [smsNotifications, setSmsNotifications] = useState(false);
  const [pushNotifications, setPushNotifications] = useState(true);
  const [autoEscalation, setAutoEscalation] = useState(true);
  const [escalationHours, setEscalationHours] = useState('24');
  const [quietHoursEnabled, setQuietHoursEnabled] = useState(false);
  const [quietHoursStart, setQuietHoursStart] = useState('22:00');
  const [quietHoursEnd, setQuietHoursEnd] = useState('08:00');

  const handleSaveSettings = () => {
    console.log('Saving settings:', {
      emailNotifications,
      smsNotifications,
      pushNotifications,
      autoEscalation,
      escalationHours,
      quietHoursEnabled,
      quietHoursStart,
      quietHoursEnd
    });
    alert('تم حفظ الإعدادات بنجاح');
    onClose();
  };

  const tabs = [
    { id: 'notifications', label: 'الإشعارات', icon: 'Bell' },
    { id: 'automation', label: 'الأتمتة', icon: 'Zap' },
    { id: 'preferences', label: 'التفضيلات', icon: 'Settings' }
  ];

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="إعدادات التنبيهات"
      icon="Settings"
      iconColor="#14B8A6"
      size="xl"
      footer={
        <div className="flex gap-3">
          <Button
            onClick={handleSaveSettings}
            className="flex-1"
            variant="primary"
          >
            <span className="flex items-center gap-2">
              <Icon name="Save" size={18} />
              حفظ الإعدادات
            </span>
          </Button>
          
          <Button
            onClick={onClose}
            variant="outline"
          >
            إلغاء
          </Button>
        </div>
      }
    >
      {/* Tabs */}
      <div className="flex gap-2 mb-6 border-b border-border">
        {tabs?.map(tab => (
          <button
            key={tab?.id}
            onClick={() => setActiveTab(tab?.id)}
            className={`flex items-center gap-2 px-4 py-2 border-b-2 transition-colors ${
              activeTab === tab?.id
                ? 'border-primary text-primary font-semibold' : 'border-transparent text-muted-foreground hover:text-foreground'
            }`}
          >
            <Icon name={tab?.icon} size={18} />
            <span>{tab?.label}</span>
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className="space-y-6">
        {activeTab === 'notifications' && (
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-foreground mb-4">قنوات الإشعارات</h3>
            
            <div className="space-y-3">
              <div className="flex items-center gap-3 p-4 border border-border rounded-lg">
                <input
                  type="checkbox"
                  id="email-notifications"
                  checked={emailNotifications}
                  onChange={(e) => setEmailNotifications(e?.target?.checked)}
                  className="w-4 h-4"
                />
                <Icon name="Mail" size={20} className="text-blue-600" />
                <label htmlFor="email-notifications" className="flex-1">
                  <span className="font-medium">البريد الإلكتروني</span>
                  <p className="text-sm text-muted-foreground">استلام التنبيهات عبر البريد الإلكتروني</p>
                </label>
              </div>

              <div className="flex items-center gap-3 p-4 border border-border rounded-lg">
                <input
                  type="checkbox"
                  id="sms-notifications"
                  checked={smsNotifications}
                  onChange={(e) => setSmsNotifications(e?.target?.checked)}
                  className="w-4 h-4"
                />
                <Icon name="MessageSquare" size={20} className="text-green-600" />
                <label htmlFor="sms-notifications" className="flex-1">
                  <span className="font-medium">رسائل SMS</span>
                  <p className="text-sm text-muted-foreground">استلام التنبيهات العاجلة عبر الرسائل النصية</p>
                </label>
              </div>

              <div className="flex items-center gap-3 p-4 border border-border rounded-lg">
                <input
                  type="checkbox"
                  id="push-notifications"
                  checked={pushNotifications}
                  onChange={(e) => setPushNotifications(e?.target?.checked)}
                  className="w-4 h-4"
                />
                <Icon name="Bell" size={20} className="text-purple-600" />
                <label htmlFor="push-notifications" className="flex-1">
                  <span className="font-medium">إشعارات النظام</span>
                  <p className="text-sm text-muted-foreground">إشعارات فورية داخل النظام</p>
                </label>
              </div>
            </div>

            <div className="mt-6 p-4 bg-muted/30 rounded-lg">
              <h4 className="font-semibold mb-3">أولويات الإشعارات</h4>
              <div className="space-y-2 text-sm">
                <div className="flex items-center justify-between p-2 bg-background rounded">
                  <span className="flex items-center gap-2">
                    <div className="w-3 h-3 bg-red-500 rounded-full"></div>
                    عاجل
                  </span>
                  <span className="text-muted-foreground">جميع القنوات</span>
                </div>
                <div className="flex items-center justify-between p-2 bg-background rounded">
                  <span className="flex items-center gap-2">
                    <div className="w-3 h-3 bg-orange-500 rounded-full"></div>
                    عالي
                  </span>
                  <span className="text-muted-foreground">بريد + نظام</span>
                </div>
                <div className="flex items-center justify-between p-2 bg-background rounded">
                  <span className="flex items-center gap-2">
                    <div className="w-3 h-3 bg-yellow-500 rounded-full"></div>
                    متوسط
                  </span>
                  <span className="text-muted-foreground">نظام فقط</span>
                </div>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'automation' && (
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-foreground mb-4">قواعد الأتمتة</h3>
            
            <div className="space-y-4">
              <div className="flex items-center gap-3 p-4 border border-border rounded-lg">
                <input
                  type="checkbox"
                  id="auto-escalation"
                  checked={autoEscalation}
                  onChange={(e) => setAutoEscalation(e?.target?.checked)}
                  className="w-4 h-4"
                />
                <label htmlFor="auto-escalation" className="flex-1">
                  <span className="font-medium">التصعيد التلقائي</span>
                  <p className="text-sm text-muted-foreground">تصعيد التنبيهات غير المعالجة تلقائياً</p>
                </label>
              </div>

              {autoEscalation && (
                <div className="mr-7 p-4 bg-muted/30 rounded-lg">
                  <label className="block text-sm font-medium mb-2">التصعيد بعد</label>
                  <select
                    value={escalationHours}
                    onChange={(e) => setEscalationHours(e?.target?.value)}
                    className="w-full px-3 py-2 border border-border rounded-lg bg-background"
                  >
                    <option value="6">6 ساعات</option>
                    <option value="12">12 ساعة</option>
                    <option value="24">24 ساعة</option>
                    <option value="48">48 ساعة</option>
                  </select>
                </div>
              )}

              <div className="p-4 border border-border rounded-lg">
                <div className="flex items-center gap-2 mb-3">
                  <Icon name="Zap" size={18} className="text-yellow-600" />
                  <span className="font-medium">قواعد التوكيل التلقائي</span>
                </div>
                <div className="space-y-2 text-sm">
                  <div className="flex items-center justify-between p-2 bg-muted/30 rounded">
                    <span>متابعة العملاء</span>
                    <span className="text-muted-foreground">→ فريق المبيعات</span>
                  </div>
                  <div className="flex items-center justify-between p-2 bg-muted/30 rounded">
                    <span>تنبيهات الصيانة</span>
                    <span className="text-muted-foreground">→ فريق الصيانة</span>
                  </div>
                  <div className="flex items-center justify-between p-2 bg-muted/30 rounded">
                    <span>مواعيد العقود</span>
                    <span className="text-muted-foreground">→ الشؤون القانونية</span>
                  </div>
                </div>
              </div>

              <div className="p-4 border border-border rounded-lg">
                <div className="flex items-center gap-2 mb-3">
                  <Icon name="Clock" size={18} className="text-blue-600" />
                  <span className="font-medium">التذكيرات التلقائية</span>
                </div>
                <div className="space-y-2">
                  <label className="flex items-center gap-2">
                    <input type="checkbox" defaultChecked className="w-4 h-4" />
                    <span className="text-sm">تذكير يومي بالتنبيهات المعلقة</span>
                  </label>
                  <label className="flex items-center gap-2">
                    <input type="checkbox" defaultChecked className="w-4 h-4" />
                    <span className="text-sm">تذكير بالمواعيد النهائية القريبة</span>
                  </label>
                  <label className="flex items-center gap-2">
                    <input type="checkbox" className="w-4 h-4" />
                    <span className="text-sm">ملخص أسبوعي للتنبيهات</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'preferences' && (
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-foreground mb-4">التفضيلات الشخصية</h3>
            
            <div className="space-y-4">
              <div className="p-4 border border-border rounded-lg">
                <div className="flex items-center gap-3 mb-4">
                  <input
                    type="checkbox"
                    id="quiet-hours"
                    checked={quietHoursEnabled}
                    onChange={(e) => setQuietHoursEnabled(e?.target?.checked)}
                    className="w-4 h-4"
                  />
                  <label htmlFor="quiet-hours" className="flex-1">
                    <span className="font-medium">ساعات الهدوء</span>
                    <p className="text-sm text-muted-foreground">إيقاف الإشعارات خلال أوقات محددة</p>
                  </label>
                </div>

                {quietHoursEnabled && (
                  <div className="grid grid-cols-2 gap-4 mr-7">
                    <div>
                      <label className="block text-sm font-medium mb-2">من الساعة</label>
                      <input
                        type="time"
                        value={quietHoursStart}
                        onChange={(e) => setQuietHoursStart(e?.target?.value)}
                        className="w-full px-3 py-2 border border-border rounded-lg bg-background"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium mb-2">إلى الساعة</label>
                      <input
                        type="time"
                        value={quietHoursEnd}
                        onChange={(e) => setQuietHoursEnd(e?.target?.value)}
                        className="w-full px-3 py-2 border border-border rounded-lg bg-background"
                      />
                    </div>
                  </div>
                )}
              </div>

              <div className="p-4 border border-border rounded-lg">
                <h4 className="font-semibold mb-3">تفضيلات العرض</h4>
                <div className="space-y-2">
                  <label className="flex items-center gap-2">
                    <input type="checkbox" defaultChecked className="w-4 h-4" />
                    <span className="text-sm">إظهار التنبيهات المحلولة</span>
                  </label>
                  <label className="flex items-center gap-2">
                    <input type="checkbox" defaultChecked className="w-4 h-4" />
                    <span className="text-sm">تجميع التنبيهات المتشابهة</span>
                  </label>
                  <label className="flex items-center gap-2">
                    <input type="checkbox" className="w-4 h-4" />
                    <span className="text-sm">إخفاء التنبيهات منخفضة الأولوية</span>
                  </label>
                </div>
              </div>

              <div className="p-4 border border-border rounded-lg">
                <h4 className="font-semibold mb-3">الفلاتر الافتراضية</h4>
                <div className="space-y-3">
                  <div>
                    <label className="block text-sm font-medium mb-2">العرض الافتراضي</label>
                    <select className="w-full px-3 py-2 border border-border rounded-lg bg-background">
                      <option>جميع التنبيهات</option>
                      <option>غير المقروءة فقط</option>
                      <option>الموكلة لي</option>
                      <option>العاجلة فقط</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-medium mb-2">الترتيب الافتراضي</label>
                    <select className="w-full px-3 py-2 border border-border rounded-lg bg-background">
                      <option>الأحدث أولاً</option>
                      <option>الأولوية</option>
                      <option>الموعد النهائي</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default AlertSettingsModal;